// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"688":"b6151b6d","793":"25dc53eb"}[chunkId] + ".chunk.css";
};